import { useState } from 'react';
import { IconPlay } from './Icons';

export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/sddefault.jpg`;

/**
 * Lightweight YouTube embed: shows the poster and only loads YouTube's player
 * once someone presses play (faster page, no tracking until then).
 */
export default function YouTube({ id, title = 'Video', autoPlay = false }) {
  const [active, setActive] = useState(autoPlay);
  const [poster, setPoster] = useState(ytThumb(id));
  if (!id) return null;
  return (
    <div className="yt">
      {active ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`}
          title={title}
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
        />
      ) : (
        <button type="button" className="yt-poster" onClick={() => setActive(true)} aria-label={`Play video: ${title}`}>
          <img
            src={poster}
            alt=""
            loading="lazy"
            onError={() => setPoster(`https://i.ytimg.com/vi/${id}/hqdefault.jpg`)}
          />
          <span className="yt-play"><IconPlay /></span>
        </button>
      )}
    </div>
  );
}
